import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { RFQ } from '@app/core/quotes';

@Component({
  selector: 'cnc-rfq-stock-locations',
  templateUrl: './rfq-stock-locations.component.html',
  styleUrls: ['./rfq-stock-locations.component.scss'],
})
export class RfqStockLocationsComponent implements OnInit {
  constructor() {}

  @Input() locationStocks :any;
  @Input() collapse :boolean;
  @Input()
  rfq :RFQ;

  consolidatedStocks :any[] = [];

  showFull :boolean;
  locations :any[] = [];

  ngOnInit() :void {
    this.processStockLocations();
  }

  ngOnChanges({ locationStocks } :SimpleChanges) :void {
    if (locationStocks && locationStocks.currentValue) {
      this.processStockLocations();
    }
  }

  processStockLocations() :void {
    const consolidatedStocks :any[] = [];

    this.locationStocks.forEach((stock :any) => {
      const stockCopy = { ...stock, stockLocations: [] };
      stock?.stockLocations?.forEach((location :any) => {
        const existingLocation = stockCopy.stockLocations.find(
          (loc) => loc.locationName === location.locationName,
        );

        if (existingLocation) {
          existingLocation.pivot.onhandQuantity =
            parseFloat(existingLocation.pivot.onhandQuantity) +
            parseFloat(location.pivot.onhandQuantity);

          existingLocation.pivot.reservedQuantity =
            parseFloat(existingLocation.pivot.reservedQuantity) +
            parseFloat(location.pivot.reservedQuantity);
        } else {
          stockCopy.stockLocations.push({
            ...location,
            pivot: { ...location.pivot },
          });
        }
      });

      consolidatedStocks.push(stockCopy);
    });

    this.locationStocks = consolidatedStocks;
    this.locations = consolidatedStocks
      .flatMap((stock) => stock.stockLocations)
      .slice(0, 2);
  }
}
